"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = notify;
function notify() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _p$enableNotification = p.enableNotifications,
    enableNotifications = _p$enableNotification === void 0 ? true : _p$enableNotification,
    notifyResolve = p.notifyResolve,
    notifyReject = p.notifyReject;
  if (!("Notification" in window)) {
    if (notifyReject) {
      notifyReject({
        err: {
          message: "Browser does not support notifications"
        }
      });
    }
  } else if (Notification.permission === "granted") {
    navigator.serviceWorker.ready.then(function (reg) {
      if (notifyResolve) {
        return notifyResolve({
          reg: reg
        });
      }
    });
  } else if (Notification.permission !== "denied" && enableNotifications) {
    Notification.requestPermission(function (permission) {
      if (permission === "granted") {
        navigator.serviceWorker.ready.then(function (reg) {
          if (notifyResolve) {
            return notifyResolve({
              reg: reg
            });
          }
        });
      } else {
        if (notifyReject) {
          notifyReject({
            info: {
              message: "User refused the permission request for notifications"
            }
          });
        }
      }
    });
  } else {
    if (enableNotifications) {
      notifyReject({
        info: {
          message: "User refused the permission request for notifications"
        }
      });
    } else {
      notifyReject({
        info: {
          message: "Notifications not enabled"
        }
      });
    }
  }
}